import { Action, handleActions } from 'redux-actions'
import { takeLatest } from 'redux-saga/effects'
import { oc } from 'ts-optchain'

import { fetchScheduleHistoryDetail } from '@/api/SchedulePaymentApi'
import {
  EmptyScheduledTransferHistoryDetail,
  ISchedulePaymentIdentity,
} from '@/domains/SchedulePaymentDomain'
import { IScheduledTransferHistoryDetail } from '@/domains/SchedulePaymentDomain'
import { IRootState } from '@/modules'
import { createFetchAction, createSaga } from '@/utils/actionUtils'
import { apiFailureReducer } from '@/utils/reducerUtils'

export const SCHEDULE_PAYMENT_HISTORY_DETAIL = 'SchedulePaymentHistoryDetail'

interface ISchedulePaymentHistoryDetailState {
  scheduledTransferHistory: IScheduledTransferHistoryDetail
}

const initialState: ISchedulePaymentHistoryDetailState = {
  scheduledTransferHistory: EmptyScheduledTransferHistoryDetail,
}

export const schedulePaymentHistoryDetailAsync = createFetchAction<ISchedulePaymentIdentity>(
  SCHEDULE_PAYMENT_HISTORY_DETAIL,
)

export const reducer = {
  [schedulePaymentHistoryDetailAsync.SUCCESS]: (
    state: ISchedulePaymentHistoryDetailState,
    action: Action<any>,
  ) => {
    return {
      ...state,
      scheduledTransferHistory: action.payload,
    }
  },
  [schedulePaymentHistoryDetailAsync.FAILURE]: apiFailureReducer,
}

export const schedulePaymentHistoryDetailSelector = {
  scheduledTransferHistory: (state: IRootState) =>
    oc(state[SCHEDULE_PAYMENT_HISTORY_DETAIL]).scheduledTransferHistory(
      initialState.scheduledTransferHistory,
    ),
}

export const schedulePaymentHistoryDetailReducer = handleActions(reducer, initialState)
export const schedulePaymentHistoryDetailSaga = [
  takeLatest(
    schedulePaymentHistoryDetailAsync.FETCH,
    createSaga<ISchedulePaymentIdentity>(
      schedulePaymentHistoryDetailAsync,
      fetchScheduleHistoryDetail,
    ),
  ),
]
